
import { SvgChevronLeft, SvgDocument, SvgFolderAdd, SvgUpload } from "@itwin/itwinui-icons-react";
import { Header, IconButton, Tooltip } from "@itwin/itwinui-react";
import styles from "./Toolbar.module.css";

interface ToolbarProps {
  onNewFolder: () => void;
  onNewFile: () => void;
  onUpload: () => void;
  onCollapse: () => void;
  expanded: boolean;
}

export const Toolbar = ({ onNewFolder, onNewFile, onUpload, onCollapse }: ToolbarProps) => {

  return (
    <Header
      appLogo={null}
      isSlim={true}
      className={styles.hideLogoDivider}
      breadcrumbs={[
        <Tooltip key="new-file" content={"Create new file"} placement="bottom" delay={500}>
          <IconButton styleType="borderless" onClick={(event) => { event.currentTarget.blur(); onNewFile() }}><SvgDocument className={styles.iconMuted} /></IconButton>
        </Tooltip>,
        <Tooltip key="new-folder" content={"Create new folder"} placement="bottom" delay={500}>
          <IconButton styleType="borderless" onClick={(event) => { event.currentTarget.blur(); onNewFolder() }}><SvgFolderAdd className={styles.iconMuted} /></IconButton>
        </Tooltip>,
        <Tooltip key="upload-file" content={"Upload files"} placement="bottom" delay={500} >
          <IconButton styleType="borderless" onClick={onUpload}><SvgUpload className={styles.iconMuted} /></IconButton>
        </Tooltip>,

      ]}
      actions={[
        <Tooltip key="collapse-btn" content={"Hide file explorer"} placement="bottom" delay={500}>
          <IconButton styleType="borderless" onClick={onCollapse} data-testid="atp-hide-file-explorer"><SvgChevronLeft /></IconButton>
        </Tooltip>
      ]}
    />
  )
}